export const dataGridSx = (pallet: any) => ({
  backgroundColor: pallet.white,
  border: '1px solid ' + pallet.divider,
  borderRadius: '16px !important',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: pallet.white,
    // borderBottom: '1px solid ' + pallet.divider,
    // borderTop: `1px solid ${pallet.grayborder}`,
    minHeight: 56,
    maxHeight: 56,
    paddingLeft: '16px !important'
  },
  '& .MuiDataGrid-root, & .MuiDataGrid-columnHeader': {
    backgroundColor: pallet.white
  },
  '& .MuiDataGrid-columnSeparator--resizable svg': {
    color: 'black',
    width: '10px',
    height: '40px'
  },
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
    padding: '4px 8px'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
    fontSize: 13
  },
  '& .MuiDataGrid-sortIcon': {
    color: `${pallet.radioButtonBorder} !important`
  },
  '& .MuiDataGrid-menuIconButton': {
    color: pallet.radioButtonBorder
  },
  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIconButton':
    {
      color: `${pallet.radioButtonBorder} !important`
    },
  '& .MuiDataGrid-cell': {
    fontSize: 13,
    lineHeight: 1.3,
    color: pallet.rowTextColor
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: pallet.borderBackground
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none'
  },
  '.MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader': {
    outline: 'none'
  },
  '& .MuiDataGrid-withBorderColor': {
    borderColor: pallet.divider
  },
  '& .MuiDataGrid-virtualScroller': {
    scrollbarWidth: 'thin'
  },
  '& .MuiDataGrid-columnHeaderTitleContainer, & .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiDataGrid-row': {
    borderBottom: `1px solid ${pallet.grayborder}`,
    paddingLeft: '16px !important',
    width: '100%'
  },
  '& .MuiDataGrid-row:nth-of-type(odd)': {
    backgroundColor: pallet.grayBackground,
    width: '100%'
  },
  '& .MuiDataGrid-row:nth-of-type(1)': {
    borderTop: `1px solid ${pallet.grayborder}`,

    width: '100%'
  },
  '& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-indeterminate': {
    color: `${pallet.formLabelText} !important`
  },
  '& .MuiTablePagination-root .MuiInputBase-root': {
    border: `1px solid ${pallet.divider}`,
    borderRadius: '10px',
    height: '30px',
    width: '58px',
    padding: '0 8px'
  }
});
